import { styled, css, kfrm } from '@elliemae/ds-system';
import { DSFloatingWrapperSlots, DSFloatingWrapperName } from '../../constants/index.js';
interface StyledAnimatedPopperPropsT {
  isOpen?: boolean;
  animationDuration?: number;
  withoutAnimation?: boolean;
}

const showAnimation = kfrm`
    from {
      opacity: 0;
      transform: scale(0.8);
    }

    to {
      opacity: 1;
      transform: scale(1);
      visibility: visible;
    }
`;

const hideAnimation = kfrm`
    from {
      opacity: 1;
      transform: scale(1);
    }

    to {
      opacity: 0;
      transform: scale(0.8);
      visibility: hidden;
    }
`;

export const StyledFloatingAnimation = styled('div', {
  name: DSFloatingWrapperName,
  slot: DSFloatingWrapperSlots.CONTENT,
})<StyledAnimatedPopperPropsT>`
  background-color: #fff;
  box-shadow:
    0 0 0 1px rgba(16, 22, 26, 0.1),
    0 2px 4px rgba(16, 22, 26, 0.2),
    0 8px 24px rgba(16, 22, 26, 0.2);

  ${({ isOpen, animationDuration, withoutAnimation }) =>
    !withoutAnimation &&
    css`
      animation: ${isOpen ? showAnimation : hideAnimation} ${animationDuration ?? 100}ms ease-in;
    `}
`;

export const StyledFloatingWrapper = styled('div', {
  name: DSFloatingWrapperName,
  slot: DSFloatingWrapperSlots.ROOT,
})``;
